import bem from "easy-bem";
import React from "react";

import "./TabBar.css";

const cn = bem("tab-bar");

export type TabBarOption<T extends string> = { value: T; label: string };

type TabBarProps<T extends string> = {
  value: T;
  options: TabBarOption<T>[];
  onChange: (value: T) => void;
};

const TabBar = <T extends string>({
  value,
  options,
  onChange,
}: TabBarProps<T>) => {
  return (
    <div className={cn()}>
      {options.map((option) => (
        <button
          key={option.value}
          className={cn("button", { active: value === option.value })}
          onClick={() => onChange(option.value)}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
};

export default TabBar;
